import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

const INIT_STATE = {
    result: null,
    openModal: false,
    loadingLogoutPrompt: false,
    error: null
};

export const logoutAllSessions = createAsyncThunk('Header/logoutPrompt/logoutAllSessions', async (args, { rejectWithValue }) => {
    try {
        const { id } = args;
        let response = await clientMutation(`
                mutation logoutAllSessions($id: Int!) {
                    result: logoutAllSessions(id: $id)
                }`,
            {
                id: id
            },
            endpoints.GRAPHQL_GENERAL
        );
        return response?.result;
    } catch (error) {
        return rejectWithValue(error.message);
    }
}
);


const logoutPromptRedux = createSlice({
    name: 'Header/logoutPrompt',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalLogoutPrompt(state, action) {
            state.openModal = true;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(logoutAllSessions.pending, (state) => {
                state.loadingLogoutPrompt = true;
                state.error = null;
            })
            .addCase(logoutAllSessions.fulfilled, (state, action) => {
                state.loadingLogoutPrompt = false;
                state.result = action.payload
            })
            .addCase(logoutAllSessions.rejected, (state, action) => {
                state.loadingLogoutPrompt = false;
                state.error = action.payload;
            });
    },
});
const { actions, reducer } = logoutPromptRedux;

export const {
    reset,
    openModalLogoutPrompt
} = actions;

export default reducer;